import Fetcher from 'services/Fetcher'
import { API_DICTIONARY, HTTP_METHODS } from 'constants/api'
import {
  VendorDetails,
  VendorInfoApiDetails,
  VendorUpdatePayload
} from '../MyCommunity/Vendors/VendorCreation/types'
import { ResponseWithPagination, VALIDATION_MESSAGES } from '../../constants'
import { notification } from '../../components/Notification'
import { TListItem } from 'components/Forms/forms.user.d'

const fetcher = new Fetcher({})

export const updateVendorInfo = async (
  data: VendorUpdatePayload,
  uuid: string
) =>
  fetcher.request<unknown, VendorDetails>({
    url: `${API_DICTIONARY.VENDORS}${uuid}/`,
    method: HTTP_METHODS.PUT,
    data,
    notification: notification,
    successMessage: VALIDATION_MESSAGES.VENDOR_HAS_BEEN_SAVED
  })

export const getVendorInfo = async (uuid: string) =>
  fetcher.request<unknown, VendorInfoApiDetails>({
    url: `${API_DICTIONARY.VENDORS}${uuid}/`,
    method: HTTP_METHODS.GET
  })

export const getCSList = async (vendorUUID: string) =>
  fetcher.request<unknown, ResponseWithPagination<TListItem>>({
    url: `${API_DICTIONARY.VENDORS}${vendorUUID}/${API_DICTIONARY.USERS}?roles=vendor_contract_steward`,
    method: HTTP_METHODS.GET
  })
